import { render, staticRenderFns } from "./RecorderButton.vue?vue&type=template&id=19f072e6&scoped=true&"
import script from "./RecorderButton.vue?vue&type=script&lang=ts&"
export * from "./RecorderButton.vue?vue&type=script&lang=ts&"
import style0 from "./RecorderButton.vue?vue&type=style&index=0&id=19f072e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f072e6",
  null
  
)

export default component.exports